import 'react-app-polyfill/stable';
import 'react-app-polyfill/ie11';

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, compose, combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';

//adding bootstrap in our project.
import 'bootstrap/dist/css/bootstrap.min.css';
import { ThemeProvider } from '@material-ui/core/styles';

import './index.css';
import App from './App';
import wmTheme from './theme/wmTheme';
import authReducer from './store/reducers/auth';
import sitesReducer from './store/reducers/sites';
import issueReducer from './store/reducers/issue';
import selectedSiteReducer from './store/reducers/selectedSite';
import { watchAuth, watchSite, watchIssue } from './store/sagas/index';
import notificationContext from './context/Notification';

const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : null || compose;

const rootReducer = combineReducers({
	auth: authReducer,
	sites: sitesReducer,
	issues: issueReducer,
	selectedSite: selectedSiteReducer
});

const sagaMiddleware = createSagaMiddleware();

const store = createStore(rootReducer, composeEnhancers(
	applyMiddleware(sagaMiddleware)
));

sagaMiddleware.run(watchAuth);
sagaMiddleware.run(watchSite);
sagaMiddleware.run(watchIssue);

const app = (
	<Provider store={store}>
		<BrowserRouter>
			<ThemeProvider theme={wmTheme}>
				<notificationContext.NotificationContextProvider>
					<App />
				</notificationContext.NotificationContextProvider>
			</ThemeProvider>
		</BrowserRouter>
	</Provider>
);

ReactDOM.render(app, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
/* serviceWorker.register(); */


